<template>
  <div id="Heshudanshuangluzhu">
    <div class="tr-header">
      <p class="title">总和路珠</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>
    <div class="tr-header-container"></div>
    <div class="tr-table-container">
      <Road v-for="(it,i) in dataSource" :data="it" :betType="betType" :key="i"></Road>
      <div>
        <p>总和85至132为大，36至83为小，84为和</p>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import format from "../../../helpers/format.js";

function setBall(start, len) {
  let res = [];
  for (let i = start; i <= len; i++) {
    res.push({
      name: `号码${i}`,
      key: `ball${i}`
    });
  }
  return res;
}
export default {
  name: "Heshudanshuangluzhu",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      selectDay: dayjs(new Date()).format("YYYY-MM-DD"),
      dataSource: [],
      balls: [],
      selectBalls: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getBallRoads(this.betType, this.dataSource);
    }
  },
  created() {
    this.reset();
  },
  methods: {
    allSelect() {
      // this.selectBalls = ["num0", "num1", "num2", "num3", "num4", "num5"];
      // this.balls.map(x => x.key);
      this.selectBalls = this.balls.map(x => x.key);
    },
    onchangeDate(date) {
      this.selectDay = dayjs(date).format("YYYY-MM-DD");
      this.getData();
    },
    reset() {
      if (this.betType == "hpten") {
        this.balls = setBall(1, 8);
        this.selectBalls = this.balls.map(x => x.key);
        // console.log(this.selectBalls, "this.selectBalls");
      }
    },
    init() {
      // this.reset();
      this.getData();
    },
    async getData() {
      let res = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        date: this.selectDay
        // pageSize: 10000,
        // startDate: this.selectDay,
        // endDate: this.selectDay
      });
      if (res.data.returnCode == "0000") {
        var arr = format.formatJson(res.data.returnList);

        if (arr.length > 0) {
          var a = this.formatList(arr[0].ball_dewdrop_json.sum);
          this.dataSource = a;
        }
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatList(obj) {
      var keys = Object.keys(obj);

      var arr = [];
      for (let i = 0; i < keys.length; i++) {
        var o = {};
        const e = keys[i];
        o[e] = obj[e];
        // var n = parseInt(e.slice(-1));
        // arr[n - 1] = o;
        arr.push(o);
      }

      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>




// WEBPACK FOOTER //
// src/pages/Trend/HPZongheluzhu/index.vue